import { encryptAesGcm } from "./crypto_aes";
import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE, SECRET_KEY, STORAGE_KEYS, isCapacitorRuntime } from "../config/vars";
import { registerStoredPushToken } from "../utils/pushInit";

function storeAccessToken(data) {
    const token = (data?.access_token || "").trim();
    const refresh = (data?.refresh_token || "").trim();
    if (!token && !refresh) return;
    try {
        if (token) localStorage.setItem(STORAGE_KEYS.MOBILE_ACCESS_TOKEN, token);
        if (refresh) localStorage.setItem(STORAGE_KEYS.MOBILE_REFRESH_TOKEN, refresh);
    } catch (_) {
        // ignore
    }
}


export async function loginUser({ email, password }) {
    try {
        if (!SECRET_KEY) {
            return { ok: false, data: { detail: "Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)" } };
        }

        // 🔒 Шифруємо пароль у форматі AES-GCM (сумісний із бекендом)
        const encryptedPassword = await encryptAesGcm(SECRET_KEY, password);

        const headers = {
            "Content-Type": "application/json",
            "X-Return-Token": "1",
        };

        const res = await apiFetch(`${API_BASE}/login/client`, {
            method: "POST",
            headers,
            body: JSON.stringify({ email, password: encryptedPassword }),
        });

        const data = await res.json();

        // Capacitor fallback: store Bearer token to avoid SameSite cookie issues
        // when backend host differs (e.g. 10.0.2.2 vs localhost).
        if (res.ok && data && data.access_token) {
            storeAccessToken(data);

            // Now that we have auth, try to register stored FCM token in backend.
            if (isCapacitorRuntime()) {
                try {
                    await registerStoredPushToken();
                } catch (_) {
                    // ignore
                }
            }
        }
        return { ok: res.ok, data };
    } catch (error) {
        console.error("Помилка шифрування або логіну:", error);
        return { ok: false, data: { detail: error.message } };
    }
}

export const forgotPassword = async (email) => {
    const response = await apiFetch(`${API_BASE}/login/client/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });

    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.detail || "Помилка при відновленні пароля");
    }
    return data;
};

export const resetPassword = async (token, newPassword) => {
    if (!SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    const encryptedNewPassword = await encryptAesGcm(SECRET_KEY, newPassword);
    const response = await apiFetch(`${API_BASE}/login/client/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: encryptedNewPassword }),
    });

    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.detail || "Помилка при зміні пароля");
    }
    return data;
};

export const getGoogleLoginUrl = () => `${API_BASE}/login/client/google`;
